var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3085_155617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00045 4.05558C8.9823 4.05558 9.77824 3.25964 9.77824 2.27779C9.77824 1.29594 8.9823 0.5 8.00045 0.5C7.0186 0.5 6.22266 1.29594 6.22266 2.27779C6.22266 3.25964 7.0186 4.05558 8.00045 4.05558Z",
    fill: "#9FA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00045 10.2782C8.9823 10.2782 9.77824 9.4823 9.77824 8.50045C9.77824 7.5186 8.9823 6.72266 8.00045 6.72266C7.0186 6.72266 6.22266 7.5186 6.22266 8.50045C6.22266 9.4823 7.0186 10.2782 8.00045 10.2782Z",
    fill: "#9FA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00045 16.5009C8.9823 16.5009 9.77824 15.705 9.77824 14.7231C9.77824 13.7413 8.9823 12.9453 8.00045 12.9453C7.0186 12.9453 6.22266 13.7413 6.22266 14.7231C6.22266 15.705 7.0186 16.5009 8.00045 16.5009Z",
    fill: "#9FA4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3085_155617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalThreeDots);
export default __webpack_public_path__ + "static/media/VerticalThreeDots.6c8615bfc404ad6ccbf99b675c6b4311.svg";
export { ForwardRef as ReactComponent };